import React from 'react';
import Popout from 'src/ui/library/Popout';
import ArrowDropDownIcon from '@material-ui/icons/KeyboardArrowDown';

export default function CasesExpandButtonPres({ orientation = 'right', dynamicOrient= 'false', label, value, children }) {
  return (
    <Popout
      casePage={true}
      orientation={orientation}
      dynamicOrient={dynamicOrient}
      autoResize={false}
      padding={16}
      trigger={
        <div className={'header-field'}>
          <label className="field-label">{label}</label>
          <div className="field-text-wrapper">
            <span className="field-text">{value}</span>
            <ArrowDropDownIcon className="field-icon" />
          </div>
        </div>
      }
      content={children}
    />
  );
}
